// extracted by mini-css-extract-plugin
export var gamePreviewBanner = "home-module--gamePreviewBanner--z3Gtr";
export var previewBtn = "home-module--previewBtn--rm5zc";